import FileSaver from "file-saver";
import * as Papa from "papaparse";
import ReactDOM from "react-dom";
import Sortable from "sortablejs";
import { RootRoute } from "@app/const";
import { defaultServiceContext } from "@app/contexts";
import DesignerSetting from "@app/DesignerSetting";
import BaseComponent from "@app/form_components/BaseComponent";
import Button from "@app/form_components/Button";
import IntentListItem from "@app/form_components/IntentListItem";
import IntentListItemEditor from "@app/form_components/IntentListItemEditor";
import { DesignClass, NodeTypeName } from "@app/types";
import {
    createUuid,
    renderByRoute,
    updateLastChange,
    updateTree
} from "@app/utilities";
import AddGlobalHandlerDialog from "@app/widgets/dialogs/AddGlobalHandlerDialog";
import GlobalHandlersCSV from "@app/widgets/dialogs/GlobalHandlersCSV";
import NewElementDialog from "@app/widgets/dialogs/NewElementDialog";

const { intentService } = defaultServiceContext;

export class GlobalIntentPage extends BaseComponent {
    /**
     * Global intent handling
     * @module GlobalIntentPage
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            mappingEditConfig: { top: 0, left: 0, width: 'auto' },
            selectedIntentListItem: {},
            search: '',
            selectedIdx: ''
        };
    }

    openAddGlobalHandlerWindow() {
        const intents = window.apm.knowledgeBase.getUniqueIntents();
        const modules = window.apm.knowledgeBase.getModules();
        const { serialized } = window.apm;
        window.apm.popup(
            "Add Global Handler",
            '<div class="add_global_handler_container" style="height: 98%"></div>',
            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + "</button> " +
            '<button class="w2ui-btn primary add-button">Add</button> ',
            [
                ".add_global_handler_container",

                () => {
                    ReactDOM.render(<AddGlobalHandlerDialog intents={intents} globalIntents={serialized.globalIntents} modules={modules} context={this} />, $('.add_global_handler_container').get(0))
                    $(".w2ui-popup").find(".add-button").on("click", function () {
                        document.dispatchEvent(
                            new CustomEvent("ev-dialog-add")
                        );

                    });

                }
            ]
            ,
            630, // height
            null, // node
            null, // treenode
            false, // showClose
            763 // width
        );
    }

    /*
     * AddModuleProperties to globalModule.
     */
    getModuleProperties(moduleId) {
        const moduleIndex = window.apm.serialized.components.modules.findIndex(mo => mo.id === moduleId);
        let moduleProps = {
            props: {
                config: {}
            }
        };
        if (moduleIndex!==-1) {
            const inputs = window.apm.getModuleInputs(window.apm.serialized.components.modules[moduleIndex]);
            const config = {
                description: window.apm.serialized.components.modules[moduleIndex].props.config.description,
                inputs: inputs,
                outputs: [],
            };
            moduleProps.id = createUuid();
            moduleProps.name = window.apm.serialized.components.modules[moduleIndex].name;
            moduleProps._class = DesignClass.module;
            moduleProps.type = "module";
            moduleProps.props = {
                config: config,
                parentComponentID: window.apm.serialized.components.modules[moduleIndex].id
            };
            if(window.apm.serialized.components.modules[moduleIndex].props.isCommonModule){
                moduleProps.props.isCommonModule = window.apm.serialized.components.modules[moduleIndex].props.isCommonModule;
                moduleProps.props.isRootModule = window.apm.serialized.components.modules[moduleIndex].props.isRootModule;
                moduleProps.props.moduleId = window.apm.serialized.components.modules[moduleIndex].props.moduleId;
            }
        }
               
        return moduleProps;
    }
    /**
     * Set config proxy; set own data model before updating context
     * @param {string} key
     * @param {Object} value
     */
    setConfig(key, value, moduleId= null) {
        if (key === "editMapping") {
            //find intent
            const global_intent = window.apm.serialized.globalIntents.find(el => el.id === this.state.selectedIntentListItem.id);

            //update with new value
            if (global_intent) {
                global_intent['module'] = value;
                global_intent['moduleProperties'] = this.getModuleProperties(value);
            }

            updateLastChange(global_intent);
            //notify apm that global state has ghanged
            window.apm.setSerializedChanged();
        }

        if (key === "newIntent") { //adds intent
            const node = window.apm.getNode(value);
            const moduleProperties = this.getModuleProperties(moduleId);
            var conditionProps = {
                "id": createUuid(),
                "_class": DesignClass.condition,
                "props": {
                    "nodeTypeName": NodeTypeName.condition,
                    "colorClass": "primary",
                    "config": {
                        "name": "",
                        "condition": [],
                        description: "",
                        inputs: [],
                        intent: value,
                        serializedCondition: ""
                    }
                }
            };
            if (node) {
                window.apm.serialized.globalIntents = [
                    {
                        author: DesignerSetting.s.author,
                        conditionProperties: conditionProps,
                        createdTime: window.apm.timestamp,
                        id: createUuid(),
                        intent: value,
                        lastLocalChange: window.apm.timestamp,
                        module: moduleId,
                        moduleProperties: moduleProperties
                    },
                    ...(window.apm.serialized.globalIntents ?? [])
                ];
                window.apm.setSerializedChanged();
                this.setState({ search: '' });
            }
        }
        updateTree();
        renderByRoute(RootRoute.intents);
    }

    // Sortable list item handler for end-of-drag events
    reload(event) {
        if (event.oldIndex === event.newIndex) {
            return;
        }
        const list = $(event.to);
        const listItems = list.find("li");
        var newList = [];
        for (var i = 0; i < listItems.length; i++) {
            newList.push({
                id: listItems[i].getAttribute("data-id"),
                intent: listItems[i].getAttribute("data-int"),
                module: listItems[i].getAttribute("data-mod"),
                conditionProperties: JSON.parse(listItems[i].getAttribute("data-conditionproperties")),
                moduleProperties: JSON.parse(listItems[i].getAttribute("data-modproperties")),
                createdTime: Number(listItems[i].getAttribute("created-time")),
                lastSavedChange: Number(listItems[i].getAttribute("lastsavedchange")),
                lastLocalChange: window.apm.timestamp
            });
        }
        window.apm.serialized.globalIntents = newList;
        window.apm.setSerializedChanged();
    }

    update(idx, value) {
        if (!window.apm.serialized.globalIntents) {
            window.apm.serialized.globalIntents = [];
            return;
        }
        window.apm.serialized.globalIntents[idx] = value;
        updateLastChange(window.apm.serialized.globalIntents[idx]);
        updateTree();
        window.apm.setSerializedChanged();
        this.forceUpdate();
    }

    removeIntent(id, event) {
        const { serialized } = window.apm;

        if (!serialized.globalIntents) {
            serialized.globalIntents = [];
            return;
        }
        const globalIntentIndex = serialized.globalIntents.findIndex(int => int.id === id);
        const intent = serialized.globalIntents[globalIntentIndex].intent;

        const li = event.target.closest("li");
		if (li.dataset.id === id) {
            // fade out list item before removing from design
			li.style.opacity = 0;
			setTimeout(() => {
				serialized.globalIntents = serialized.globalIntents.filter((globalIntent) => globalIntent.id !== id);
				window.apm.updateDeletedGlobalIntentsMap(id);
				window.apm.setSerializedChanged();
				if (serialized.globalIntents.filter((globalIntent) => globalIntent.intent === intent).length === 0) {
					var intentIndex = serialized.components.intents.findIndex((i) => i.id === intent);
					serialized.components.intents[intentIndex].isGlobalIntent = false;
					updateTree();
				}
                renderByRoute(RootRoute.intents);
			}, 250);
		} else {
			console.error("could not find matching list item");
		}
    
    }

    /**
     * Get reference to input box itself
     * @returns {jQuery}
     */
    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    bindTagWrapper() {
        const tagList = this.getDomSelf().children(".tag-items");
        if (tagList.length && !this.sortable) {
            this.sortable = Sortable.create(tagList[0], {
                ghostClass: "sortable-ghost",  // Class name for the drop placeholder
                chosenClass: "sortable-chosen",  // Class name for the chosen item
                dragClass: "sortable-drag",  // Class name for the dragging item
                onEnd: (event) => {
                    this.reload(event);
                }
            });
        }
    }
    createIntent(intentName, moduleId) {
        const newIntent = intentService.initializeIntent();
        newIntent.isGlobalIntent = true;
        newIntent.name = intentName;
        const treeDom = $('#tl_container');
        NewElementDialog.addElement(treeDom, newIntent);
        window.apm.notification.post("success", window.l.notification.new_intent);
        updateTree();
        this.setConfig("newIntent", window.apm.serialized.components.intents[window.apm.serialized.components.intents.length - 1].id, moduleId);

    }
    componentDidMount() {
        this.bindTagWrapper();
        //this.openAddGlobalHandlerWindow()
    }

    /** @inheritdoc */
    componentDidUpdate() {
        // Prevent sorting on a filtered lists.
        this.sortable.options.disabled = !!this.state.search;
    }

    initEditMappingDropdown(xPos, yPos, width) {
        this.setState({ 'mappingEditConfig': { 'isEditMapping': true, top: xPos, left: yPos, width: width } });
    }

    onEditComplete() {
        this.setState({ 'mappingEditConfig': { 'isEditMapping': false } });
    }

    setSelectedIntentListItem(intent) {
        const selectedIdx = window.apm.knowledgeBase.getIndexFromValue(intent.mod, window.apm.knowledgeBase.getModules());
        this.setState({ 'selectedIntentListItem': intent });
        this.setState({ 'selectedIdx': selectedIdx });
    }
    exportGlobalIntents() {

        const globalIntents = window.apm.serialized.globalIntents;
        let globalIntentFields = ['IntentName', 'IntentDescription', 'ModuleName'];
        let globalIntentsRowData = [globalIntentFields];
        globalIntents.map(globalIntent => {
            let row = [];
            let intent = window.apm.getNode(globalIntent.intent);
            if (intent) {
                row.push(intent.name);
                row.push(intent.props.config.description);
            }
            let module = window.apm.getNode(globalIntent.module);
            if (module) {
                row.push(module.name);
            }
            globalIntentsRowData.push(row);
        });
        const newGlobalIntentsCsv = Papa.unparse(globalIntentsRowData);
        var blob = new Blob([newGlobalIntentsCsv], { type: "csv;charset=utf-8" });

        FileSaver.saveAs(blob, "globalintents.csv");

    }

    render() {
        const { search } = this.state;
        const { serialized } = window.apm;
        const enabledModules = serialized.components.modules.filter(mod => !mod.props.config.disabledInFlow).sort((a, b) => (a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0);
        const options = enabledModules.map(mod => { return { name: mod.name, value: mod.id } });
        const optionName = (this.state.selectedIdx !== -1 && this.state.selectedIdx !== "") ? options[this.state.selectedIdx].name : '';

        const lowerCaseSearch = search.toLowerCase();
        const globalIntents = (serialized.globalIntents ?? []).filter(({ intent }) => {
            const node = window.apm.getNode(intent);
            return (
                !search
                || node.name.toLowerCase().includes(lowerCaseSearch)
                || node.props.config.description?.toLowerCase().includes(lowerCaseSearch)
            );
        });

        return (
            <div className="intents-table">

                <div className="tag-new">

                    <div className="row">

                        <div className="col-md-12">
                            <div style={{width: "50%"}}>
                                <i className="fe icon-search input-prefix-icon" />
                                <i
                                    className="fe icon-x input-suffix-icon clear-button"
                                    onClick={() => this.setState({ search: '' })}
                                    style={{ display: (search) ? 'inline' : 'none' }}
                                />
                                <input
                                    type="search"
                                    className="form-component v-marginal search"
                                    placeholder="Search Global Handlers"
                                    onChange={(event) => this.setState({ search: event.target.value })}
                                />
                            </div>

                        </div>
                        <div className="col-md-6">
                            <Button
                                label="Add Global Handler"
                                callback={() => this.openAddGlobalHandlerWindow()}
                            />
                        </div>
                        <div className="col-md-3  col-md-offset-3" style={{ display: "flex" }}>
                            <div style={{ display: "flex", paddingRight: '1em' }}>
                                <Button
                                    label="Import"
                                    desc={this.state.label}
                                    callback={() => {
                                        window.apm.popup(
                                            window.l.settings.csv_data,
                                            '<div class="custom_script_container"></div>',
                                            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' +
                                            window.l.popup.close +
                                            "</button> " +
                                            '<button class="w2ui-btn primary add-button">' +
                                            window.l.popup.upload_csv +
                                            "</button> ",
                                            [
                                                ".custom_script_container",

                                                () => {
                                                    ReactDOM.render(
                                                        <GlobalHandlersCSV />,
                                                        $(".custom_script_container").get(0)
                                                    );
                                                    $(".w2ui-popup")
                                                        .find(".add-button")
                                                        .on("click", function () {
                                                            document.dispatchEvent(
                                                                new CustomEvent("ev-dialog-add")
                                                            );
                                                        });
                                                }
                                            ]
                                        );
                                    }}
                                    context={this}
                                />
                            </div>
                            <Button label="Export" className="w2ui-btn primary" callback={() => { this.exportGlobalIntents() }} />
                        </div>

                        <div className="col-md-7">

                        </div>
                    </div>
                </div>
                <ul className="tag-items" >
                    {(globalIntents.length) ? (
                        globalIntents.map((intent, i) => (
                            <IntentListItem
                                data={intent}
                                highlight={!!search}
                                context={this}
                                tagIdx={i}
                                key={i + intent.intent + "::" + intent.module}
                            />
                        ))
                    ) : (
                        <strong>There are no Global Intents to display</strong>
                    )}
                </ul>
                {this.state.mappingEditConfig.isEditMapping &&
                    <IntentListItemEditor
                        top={this.state.mappingEditConfig.top}
                        left={this.state.mappingEditConfig.left}
                        width={this.state.mappingEditConfig.width}
                        contextClassName="editMapping"
                        options={window.apm.knowledgeBase.getModules()}
                        optionName={optionName}
                        context={this}
                        modules={serialized.components.modules}
                        valKey="editMapping"
                        selection={this.state.selectedIdx} />
                }
            </div>
        );
    }
}
